<template>
    <transition name="slide-fade">
        <div class="transfer-fail-modal" :class="{'open' : open}" v-if="open">
            <div class="modal-content">
                <div class="bg-white w-full content-wrapper p-4 text-center">
                    <div class="font-semibold text-666666">{{lbl.TransferMAAI.convert_error}}</div>
                    <div class="text-666666 py-6">{{lbl.TransferMAAI.please_contact_callcanter}}<br>1736</div>
                    <div @click="clickCancel()" class="w-full rounded-full border border-tc-black-1 text-center py-4 text-tc-black-1 cursor-pointer mb-4">
                        {{lbl.TransferMAAI.Close}}
                    </div>
                </div>
            </div>
        </div>
    </transition>

    <transition name="fade">
        <div class="modal-backdrop" v-if="open"></div>
    </transition>
</template>
<script>
import Util from "@/helper/Utility.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";

export default {
    name: "ContractCallCenterModal",
    mixins: [LocaleMixin],
    props: {
        controller: Object,
    },
    components: {
    },
    data: function() {
        return {
            open: false,

            title: '',
            message: '',
            btnOk: '',
            busModal: null,
        };
    },
    created: function() {
        this.busModal = this.controller.busModal;
    },
    mounted: function() {
        this.busModal.on('show', this.show);
        this.busModal.on('hide', this.hide);
    },
    methods: {
        show: function(config) {
            this.title = config.title;
            this.message = config.msg;
            this.btnOk = config.btnOk;

            if (Util.isEmptyStr(this.btnOk)) {
                this.btnOk = this.lbl.button.ok;
            }

            document.body.classList.add('not-scroll');
            this.open = true;
        },
        hide: function() {
            document.body.classList.remove('not-scroll');
            this.open = false;
        },
        clickOk: function () {
            this.hide();
            this.controller.sendCallbackOk();
        },
        clickCancel: function () {
            this.hide();
            this.controller.sendCallbackCancel();
        },
    },
}
</script>
<style lang="scss" scoped>
    @import "@/style/modal.scss";
    .modal {
        @extend %modal;
    }
</style>
<style lang="scss">
    @import "@/style/base/base.scss";
    @import "@/style/modal.scss";

    .transfer-fail-modal {
        @extend %modal;
        .modal-content {
            width: 500px;
            @include mobile {
                width: 366px;
            }
            .content-wrapper {
                border-radius: 40px;
            }
        }
    }
</style>
